import { writable, get } from "svelte/store";
import SlimSelect from "slim-select";
import { debounce } from "lodash";
import htmx from "htmx.org";

function createSlimSelectStore() {
  const store = writable({ selects: [], values: {} });
  function initialize(selectsInfo) {
    selectsInfo.forEach(selectInfo => {
      if (!selectInfo.element.classList.contains("ss-run")) {
        selectInfo.element.classList.add("ss-run");

        const debouncedSearch = debounce(function (
          search,
          resolve,
          reject,
          currentData
        ) {
          let concat = "?";
          if (selectInfo.ajaxUrl.indexOf("?") > 0) concat = "&";

          fetch(`${selectInfo.ajaxUrl}${concat}${selectInfo.id}=${search}`)
            .then(response => response.json())
            .then(data => {
              const options = data.map(item => ({
                text: item.text,
                value: item.text,
              }));
              resolve(options);
            })
            .catch(error => {
              reject("Failed to fetch data");
            });
        }, 300);

        const select = new SlimSelect({
          select: selectInfo.element,
          placeholder: selectInfo.placeholder,
          events: {
            search: (search, currentData) => {
              return new Promise((resolve, reject) => {
                if (search.length < 3) {
                  reject("Search must be at least 3 characters");
                } else {
                  debouncedSearch(search, resolve, reject, currentData);
                }
              });
            },
            beforeChange: () => {
              const currentState = get(store);
              currentState.selects.forEach((s) => s.setSelected(""));
            },
            afterChange: (newVal) => {
              store.update(currentState => {
                currentState.values[selectInfo.name] = newVal?.[0]?.value || '';
                return currentState;
              });
            },
          },
        });

        store.update(currentState => {
          currentState.selects.push(select);
          return currentState;
        });
      }
    });
  }

  function resetFilters() {
    store.update(currentState => {
      currentState.selects.forEach((s) => s.setSelected(""));
      currentState.values = {};
      return currentState;
    });
  }

  function performSearch(targetId) {
    const currentState = get(store);
    if (Object.keys(currentState.values).length > 0) {
      const element = htmx.closest(
        htmx.find(`#${targetId}`),
        'div[data-hx-trigger="refresh"]'
      )

      if (element) {
        htmx.ajax("GET", element.dataset.hxGet, {
          target: `#${targetId}`,
          values: {
            ...JSON.parse(element.dataset.hxVals || "{}"),
            ...currentState.values,
          },
        });
      }
    }
  }

  return {
    subscribe: store.subscribe,
    initialize,
    resetFilters,
    performSearch
  };
}

export const slimSelectStore = createSlimSelectStore();
